import React, { Component } from 'react';

import countries from './countries.js';

class InputPhoneCountries extends Component {
	constructor(props) {
		super(props);

		const language = window.navigator
			? window.navigator.language ||
			  window.navigator.systemLanguage ||
			  window.navigator.userLanguage
			: 'ru';

		this.state = {
			value: 'ru',
			text: '',
			lang: language.substr(0, 2).toLowerCase(),
			opened: false,
		};

		this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	setWrapperRef(node) {
    this.wrapperRef = node;
  }

	componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

	handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ opened: false });
    }
  }

  changeValue(value) {
  	this.setState({
  		value: value,
  		opened: false,
  		text: ''
  	});

  	const country = countries.find(c => c.code == value);
  	this.props.onChange(`+${country.phone}`);
  }

	prepareCountriesList() {
		const { value, lang, text } = this.state;
		const filteredCountries = countries.filter(
			c =>
				c.label.toLowerCase().includes(text.toLowerCase()) ||
				(c.i18n[lang] && c.i18n[lang].toLowerCase().includes(text.toLowerCase())) ||
				c.phone.includes(text.replace('+', ''))
		);

		if (filteredCountries.length == 0) {
			return (
				<button
					onClick={() => this.setState({ text: '' })}
					type="button"
					className="country-helper__line"
				>
					Ничего не найдено
				</button>
			)
		}

		return filteredCountries.map(c => {
			const label = c.i18n[lang] ? c.i18n[lang] : c.label;
			if (value != c.code) {
				const flagClasses = ['flag'];
				flagClasses.push(`flag-${c.code.toUpperCase()}`);
				return (
					<button
						key={c.code}
						onClick={() => this.changeValue(c.code)}
						type="button"
						className="country-helper__line"
					>
						<span>{label}</span>
						<span>+{c.phone}</span>
					</button>
				);
			}
			return (
				<button
					key={c.code}
					onClick={() => this.changeValue(c.code)}
					type="button"
					className="country-helper__line country-helper__line--selected"
				>
					<span>{label}</span>
					<span>+{c.phone}</span>
				</button>
			);
		});
	}

	render() {
		const { text, opened } = this.state;

		const flagClasses = ['country-helper__flag', 'flag'];
		flagClasses.push(`flag-${this.state.value.toUpperCase()}`);

		const openedClasses = ['country-helper'];
		if (opened) openedClasses.push('country-helper--opened');

		return (
			<div className={openedClasses.join(' ')}>
				<button
					className="country-helper__btn"
					type="button"
					onClick={() => this.setState({ opened: !opened })}
				></button>
				<div className={flagClasses.join(' ')}></div>
				<div className="country-helper__dropdown" ref={this.setWrapperRef}>
					<input autoComplete="off"
						type="text"
						className="inp__field"
						placeholder="Введите страну"
						value={text}
						onChange={e => this.setState({ text: e.target.value })}
					/>
					<div className="scrolled-area">{this.prepareCountriesList()}</div>
				</div>
			</div>
		);
	}
}

export default InputPhoneCountries;
